module.exports = __webpack_public_path__ + "static/img/Profile.f5308c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Profile.png
// module id = 87qT
// module chunks = 36